import { Injectable } from '@angular/core';
import { UploadStorage } from './upload-storage';
import { HttpEvent } from '@angular/common/http';
import { Settings } from '../../../core';
import { UploadedDocumentsRequestCreator } from './uploaded-documents-request-creator';
import { CategoryNaturalKey } from '../../../documents';
import { CultureInfo } from '../../../core/culture-info';
import { Observable } from 'rxjs';
import { ActivityLogger } from '../../../activities/activity-logger';

@Injectable()
export class SiteCommunicationsMassUploadStorage implements UploadStorage {
    private readonly apiPath = 'admin/uploaded-documents';

    constructor(
        private readonly settings: Settings,
        private readonly uploadRequestCreator: UploadedDocumentsRequestCreator,
        private readonly activityLogger: ActivityLogger,
    ) {
    }

    public create<T>(categoryId: CategoryNaturalKey, files: Map<File, CultureInfo>, documentMetadata: T): Observable<HttpEvent<Object>> {
        this.activityLogger.logActivity('Bulk Upload');

        return this.uploadRequestCreator.createPost(`${this.settings.apiUrl}/${this.apiPath}/site-communications/mass-upload`, files, documentMetadata);
    }

    public update(categoryId: CategoryNaturalKey, files: Map<File, CultureInfo>, documentId: string, auditTrailReason: string): Observable<HttpEvent<Object>> {
        throw new Error('not implemented');
    }
}